// Subscription Helper for ReCharge
document.addEventListener('DOMContentLoaded', function() {
  // Add a message to indicate subscription mode

  // Clean up any remaining error messages
  cleanupErrorMessages();

  // Set up subscription add to cart buttons
  setupSubscriptionAddToCart();
});

/**
 * Clean up any remaining error messages
 */
function cleanupErrorMessages() {
  // Look for error messages in the DOM
  const errorElements = document.querySelectorAll('.product-item__quick-buy');

  errorElements.forEach(container => {
    const errorText = container.textContent;
    if (errorText && errorText.includes('Variant can only be purchased with a selling plan')) {
      // Get the product URL
      const productItem = container.closest('.product-item');
      if (!productItem) return;

      const productLink = productItem.querySelector('a.product-item__title');
      if (!productLink) return;

      const productUrl = productLink.getAttribute('href');

      // Replace the error message with a proper button that links to the product page
      container.innerHTML = `
        <a href="${productUrl}" class="button subscription-button button--regular button--fullwidth">
          <span class="button__text">Select Subscription Options</span>
        </a>
      `;
    }
  });
}

/**
 * Set up subscription add to cart buttons
 */
function setupSubscriptionAddToCart() {
  // Find all subscription add to cart buttons
  const subscriptionButtons = document.querySelectorAll('[data-js-subscription-add-to-cart]');

  subscriptionButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();

      // Show loading state
      button.classList.add('working');

      // Get product data
      const productId = button.dataset.productId;
      const variantId = button.dataset.variantId;
      const sellingPlanId = button.dataset.sellingPlanId;

      // Add to cart with selling plan
      addToCartWithSellingPlan(variantId, sellingPlanId, 1, button);
    });
  });
}

/**
 * Add a product to cart with a selling plan
 */
function addToCartWithSellingPlan(variantId, sellingPlanId, quantity, button) {
  // Validate inputs
  if (!variantId) {
    console.error('Error: No variant ID provided');
    showAddToCartError(button, 'Error: No variant ID provided');
    return;
  }

  if (!sellingPlanId) {
    console.error('Error: No selling plan ID provided');
    showAddToCartError(button, 'This product requires a subscription plan');

    // Redirect to product page if no selling plan ID is available
    const productItem = button.closest('.product-item');
    if (productItem) {
      const productLink = productItem.querySelector('a.product-item__title');
      if (productLink) {
        window.location.href = productLink.getAttribute('href');
        return;
      }
    }
    return;
  }

  // Create the cart item data
  const formData = {
    items: [
      {
        id: variantId,
        quantity: quantity,
        selling_plan: sellingPlanId
      }
    ]
  };

  console.log('Adding to cart with selling plan:', formData);

  // Add to cart via AJAX
  fetch(`${window.Shopify.routes.root}cart/add.js`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    if (!response.ok) {
      return response.json().then(errorData => {
        throw new Error(errorData.description || 'Error adding product to cart');
      });
    }
    return response.json();
  })
  .then(data => {
    // Handle success
    console.log('Product added to cart with subscription:', data);

    // Update cart count
    updateCartCount();

    // Show success message
    showAddToCartSuccess(button);
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    const errorMessage = error.message || 'There was an error adding this product to your cart.';
    showAddToCartError(button, errorMessage);

    // If the error is about requiring a selling plan, redirect to product page
    if (errorMessage.includes('selling plan') || errorMessage.includes('subscription')) {
      const productItem = button.closest('.product-item');
      if (productItem) {
        const productLink = productItem.querySelector('a.product-item__title');
        if (productLink) {
          setTimeout(() => {
            window.location.href = productLink.getAttribute('href');
          }, 1500);
        }
      }
    }
  })
  .finally(() => {
    // Remove loading state
    button.classList.remove('working');
  });
}

/**
 * Update the cart count in the header
 */
function updateCartCount() {
  fetch(`${window.Shopify.routes.root}cart.js`)
    .then(response => response.json())
    .then(cart => {
      document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
        elm.textContent = cart.item_count;
      });
      document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
        elm.textContent = "$" + cart.total_price / 100;
      });
    })
    .catch(error => console.error('Error fetching cart:', error));
}

/**
 * Show success message after adding to cart
 */
function showAddToCartSuccess(button) {
  // Create success message
  const message = document.createElement('div');
  message.className = 'add-to-cart-success';
  message.innerHTML = 'Added to cart!';
  message.style.cssText = 'position: absolute; top: -30px; left: 50%; transform: translateX(-50%); background-color: #4CAF50; color: white; padding: 5px 10px; border-radius: 3px; font-size: 12px; opacity: 0; transition: opacity 0.3s ease;';

  // Add to DOM
  button.style.position = 'relative';
  button.appendChild(message);

  // Show and then hide
  setTimeout(() => {
    message.style.opacity = '1';
    setTimeout(() => {
      message.style.opacity = '0';
      setTimeout(() => {
        message.remove();
      }, 300);
    }, 2000);
  }, 10);
}

/**
 * Show error message after failed add to cart
 */
function showAddToCartError(button, errorMessage) {
  // Create error message
  const message = document.createElement('div');
  message.className = 'add-to-cart-error';
  message.innerHTML = errorMessage;
  message.style.cssText = 'position: absolute; top: -30px; left: 50%; transform: translateX(-50%); background-color: #F44336; color: white; padding: 5px 10px; border-radius: 3px; font-size: 12px; opacity: 0; transition: opacity 0.3s ease; white-space: nowrap;';

  // Add to DOM
  button.style.position = 'relative';
  button.appendChild(message);

  // Show and then hide
  setTimeout(() => {
    message.style.opacity = '1';
    setTimeout(() => {
      message.style.opacity = '0';
      setTimeout(() => {
        message.remove();
      }, 300);
    }, 3000);
  }, 10);
}

// Run the helper again when the page content changes (for infinite scroll or AJAX loads)
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes && mutation.addedNodes.length > 0) {
      // Check if any of the added nodes contain error messages or subscription buttons
      setTimeout(() => {
        cleanupErrorMessages();
        setupSubscriptionAddToCart();
      }, 500);
    }
  });
});

// Start observing the document with the configured parameters
observer.observe(document.body, { childList: true, subtree: true });
